import mutations from "./mutations";
import * as actions from "./actions";
import * as getters from "./getters";

// state
let state = {
    stripe: null,
    intentToken: null,
    paymentMethods: [],
    planId: null
}

export default {mutations, actions, state, getters}


// WEBPACK FOOTER //
// ./src/store/modules/api/index.js